import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/intake/portals')({});
